module.exports = __webpack_public_path__ + "images/emoji/neutral_face.1946287de97cb01b203d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/neutral_face.png
// module id = tnfA
// module chunks = 2